import React from "react";
import { FaFileExport } from "react-icons/fa";
import { getUser } from "../utils/common";
import { useSelector } from "react-redux";
import { convertToCairoTime } from "../../utils/helper";

const AttandanceTable = ({ selectedDates }) => {
  const { setting } = useSelector((state) => state);

  const user = getUser();
  const findRole = user[0]?.roles[0]?.permissions;
  const permissions = [];
  findRole?.map((item) => permissions?.push(item.permissions));

  const exportToCSV = () => {
    const table = document.getElementById("table-to-xls");
    let csv = [];
    const rows = table.querySelectorAll("tr");
    
    for (let i = 0; i < rows.length; i++) {
      let row = [], cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) {
        row.push('"' + cols[j].innerText.replace(/"/g, '""') + '"');
      }
      csv.push(row.join(","));
    }
    
    const csvString = csv.join("\n");
    const blob = new Blob(["\uFEFF" + csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    
    let filename = "Attendance_Records.csv";
    if (selectedDates && selectedDates.length === 2) {
      if (selectedDates[0] === selectedDates[1]) {
        filename = `Attendance_Records_${selectedDates[0]}.csv`;
      } else {
        filename = `Attendance_Records_${selectedDates[0]}_to_${selectedDates[1]}.csv`;
      }
    }
    
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="table-responsive">
        <div className="card">
          <div className="overflow-hidden">
            <div className="absolute right-6 items-center justify-center top-3 flex gap-2 mb-3 z-10">
              <small>Export</small>
              <button
                className="btn btn-sm btn-primary light flex items-center svg-btn shadow-none z-15"
                onClick={exportToCSV}
                title="Export to CSV"
              >
                <FaFileExport />
              </button>
            </div>
            <div className="card-body mt-10 relative">
              <div className="table-responsive">
              <table id="table-to-xls" className="display table-hover w-full">
                <thead>
                  <tr className="border-b">
                    <th className="py-6">Date</th>
                    <th className="py-6">Time</th>
                    <th className="py-6">Names</th>
                    <th className="py-6">Login Location</th>
                    <th className="py-6">Logout Location</th>
                    <th className="py-6">Logout Date</th>
                    <th className="py-6">Logout Time</th>
                  </tr>
                </thead>
                <tbody>
                  {setting?.allAttandance?.map((item) => {
                    return (
                      <tr key={item._id} className="border-b">
                        <td className="py-3">{item?.date?.slice(0, 10)}</td>
                        <td className="py-3">
                          {`${convertToCairoTime(item?.date)}`}
                        </td>
                        <td className="py-3 capitalize">
                          {`${item?.userId?.firstname} ${item?.userId?.lastname}`}
                        </td>
                        <td className="py-3 uppercase">
                          {item?.status?.split("_")?.join(" ")}
                        </td>
                        <td className="py-3 uppercase">
                          {item?.loggout_status ? item.loggout_status.split("_").join(" ") : "-"}
                        </td>
                        <td className="py-3">
                          {item?.logoutDate ? item.logoutDate.slice(0, 10) : "-"}
                        </td>
                        <td className="py-3">
                          {item?.logoutDate ? convertToCairoTime(item.logoutDate) : "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default AttandanceTable;
